import './index.scss'
$("header").removeClass("head1");
$(".forget").click(function () {
    $(".pop").removeClass("active");
    $(".pop2").addClass("active");
})
$(".register").click(function () {
    $(".pop").removeClass("active");
    $(".pop3").addClass("active");
})